export const MENU_STATUSES = {
  all: "Semua",
  strong: "Laris & Untung",
  thin: "Margin Tipis",
  promote: "Perlu Dipromosikan",
  review: "Perlu Evaluasi",
  insufficient: "Data Belum Cukup",
};

const number = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);

export const buildProductAnalysis = (products = []) => {
  const grouped = new Map();
  products.forEach((product) => {
    const key = product.group_id != null ? `group-${product.group_id}` : `product-${product.id}`;
    const group = grouped.get(key) || {
      key,
      name: product.group_name || product.name,
      image: product.image_path || product.image,
      total_qty: 0,
      total_sales: 0,
      total_cogs: 0,
      variants: [],
    };
    const variant = {
      ...product,
      total_qty: number(product.total_qty),
      total_sales: number(product.total_sales),
      total_cogs: number(product.total_cogs),
    };
    variant.total_profit = variant.total_sales - variant.total_cogs;
    group.variants.push(variant);
    group.total_qty += variant.total_qty;
    group.total_sales += variant.total_sales;
    group.total_cogs += variant.total_cogs;
    grouped.set(key, group);
  });
  const groups = Array.from(grouped.values());
  const totals = groups.reduce(
    (sum, group) => ({
      total_qty: sum.total_qty + group.total_qty,
      total_sales: sum.total_sales + group.total_sales,
      total_cogs: sum.total_cogs + group.total_cogs,
    }),
    { total_qty: 0, total_sales: 0, total_cogs: 0 },
  );
  totals.total_profit = totals.total_sales - totals.total_cogs;
  const averageQty = groups.length ? totals.total_qty / groups.length : 0;
  const averageMargin = totals.total_sales > 0 ? (totals.total_profit / totals.total_sales) * 100 : 0;
  const enoughData = totals.total_qty >= 30 && groups.length >= 3;
  return {
    totals,
    averageQty,
    averageMargin,
    groups: groups.map((group) => {
      const profit = group.total_sales - group.total_cogs;
      const margin = group.total_sales > 0 ? (profit / group.total_sales) * 100 : null;
      let status = "insufficient";
      if (profit <= 0) status = "review";
      else if (enoughData && group.total_qty >= 5) {
        const popular = group.total_qty >= averageQty;
        const profitable = margin >= averageMargin;
        status = popular ? (profitable ? "strong" : "thin") : profitable ? "promote" : "review";
      }
      return { ...group, total_profit: profit, margin, status };
    }),
  };
};

export const filterProductAnalysis = (groups, search, status, sort) => {
  const query = search.trim().toLocaleLowerCase("id-ID");
  return groups
    .filter(
      (group) =>
        (status === "all" || group.status === status) &&
        [group.name, ...group.variants.map((variant) => variant.variant_label || variant.name)].some((name) =>
          String(name || "")
            .toLocaleLowerCase("id-ID")
            .includes(query),
        ),
    )
    .sort((a, b) => number(b[sort]) - number(a[sort]) || String(a.name).localeCompare(String(b.name), "id"));
};
